import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "./data";

// Secondary "transformational" button placed under each section.
export function TransformButton({
  label
}: {
  label: string;
}) {
  const handleClick = () => {
    if (typeof window !== "undefined" && (window as any).fbq) {
      (window as any).fbq("track", "InitiateCheckout");
    }
  };
  return <div className="mt-8 flex justify-center px-4" data-id="element-270" data-mp="cs9srr649plg">
      <a href={CHECKOUT_URL} onClick={handleClick} className="group inline-flex items-center gap-2 rounded-full border-2 border-[var(--brand)] bg-white px-6 py-3 text-center text-sm font-bold text-[var(--brand)] shadow-sm transition-all hover:bg-[var(--brand)] hover:text-white sm:text-base" data-id="element-271" data-mp="cqyolq8reftt">
        {label}
        <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-1" data-id="element-272" data-mp="2oh137ksgz1v1" />
      </a>
    </div>;
}